import { BaseSopOperation } from "./_Base";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
import { isBooleanTrue } from "../../../core/BooleanValue";
import {
  DEFAULT_SPOT_LIGHT_PARAMS,
  SpotLightContainer
} from "../../../core/lights/SpotLight";
export class SpotLightSopOperation extends BaseSopOperation {
  static type() {
    return "spotLight";
  }
  cook(inputCoreGroups, params) {
    const container = this.createLight(params);
    this.updateLightParams(container, params);
    this.updateShadowParams(container, params);
    container.updateParams(params);
    container.updateHelper();
    container.updateVolumetric();
    return this.createCoreGroupFromObjects([container]);
  }
  createLight(params) {
    var _a;
    const container = new SpotLightContainer(params, ((_a = this._node) == null ? void 0 : _a.name()) || "_");
    const light = container.light();
    light.matrixAutoUpdate = false;
    light.castShadow = true;
    light.shadow.bias = -1e-3;
    light.shadow.mapSize.x = 1024;
    light.shadow.mapSize.y = 1024;
    light.shadow.camera.near = 0.1;
    return container;
  }
  updateLightParams(container, params) {
    const light = container.light();
    light.color = params.color;
    light.intensity = params.intensity;
    light.angle = params.angle * (Math.PI / 180);
    light.penumbra = params.penumbra;
    light.decay = params.decay;
    light.distance = params.distance;
  }
  updateShadowParams(container, params) {
    const light = container.light();
    light.castShadow = isBooleanTrue(params.castShadow);
    light.shadow.autoUpdate = isBooleanTrue(params.shadowAutoUpdate);
    light.shadow.needsUpdate = isBooleanTrue(params.shadowUpdateOnNextRender);
    light.shadow.mapSize.copy(params.shadowRes);
    const map = light.shadow.map;
    if (map) {
      map.setSize(params.shadowRes.x, params.shadowRes.y);
    }
    light.shadow.bias = params.shadowBias;
    light.shadow.radius = params.shadowRadius;
    light.shadow.camera.near = params.shadowNear;
    light.shadow.camera.far = params.shadowFar;
    light.shadow.camera.updateProjectionMatrix();
    container.updateHelper();
  }
}
SpotLightSopOperation.DEFAULT_PARAMS = DEFAULT_SPOT_LIGHT_PARAMS;
SpotLightSopOperation.INPUT_CLONED_STATE = InputCloneMode.NEVER;
